import { BaseObject } from "./BaseObject.js";

export class LineObject extends BaseObject {
  constructor(options = {}) {
    super({
      ...options,
      type: "line",
      tool: options.tool ?? "line"
    });
  }
}
